import React from 'react';
import PropTypes from 'prop-types';
import { sources } from './sources';
import { Img } from './layout';

export const Icon = ({ name, activeOn, location: { pathname }, style, active }) => {
  const isActive = active || pathname === activeOn;
  return (
    <Img src={sources[`${name}${isActive ? 'Active' : ''}`]} alt={name} style={style} />
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  activeOn: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string),
  active: PropTypes.bool,
};

Icon.defaultTypes = {
  activeOn: '',
  style: {},
  active: false,
};



// WEBPACK FOOTER //
// ./components/atoms/Icon/Icon.js